export default "__VITE_ASSET__ad60465d__"